import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getStaticImageUrl } from 'client/utils/image-helpers';

import './price-comparison-bar.scss';

export function TooltipMarker({ dot, setRef }) {
  const { id, position, theme, hasShadow, hasGem, label } = dot;

  return (
    <div className="pos-a top-50 translate-middle" style={{ left: `${position}%` }}>
      <div className="dot bg-cool-gray-10 border border-2 border-white rounded-circle" />

      <div
        ref={setRef(id)}
        className={classnames(
          `callout pos-a start-50 d-flex align-items-center rounded-pill px-0_5 py-0_25 theme-${theme}`,
          { 'callout-shadow': hasShadow }
        )}
      >
        {hasGem && (
          <img src={getStaticImageUrl(`/icons/lease-deals-gem.svg`)} alt="" className="gem-icon text-gem-5 me-0_25" />
        )}

        <span className="text-nowrap">
          {label.normal}
          {label.bold && <strong>{label.bold}</strong>}
          {label.suffix}
        </span>
      </div>
    </div>
  );
}

TooltipMarker.propTypes = {
  dot: PropTypes.shape({
    id: PropTypes.string.isRequired,
    position: PropTypes.number.isRequired,
    theme: PropTypes.string.isRequired,
    hasShadow: PropTypes.bool,
    hasGem: PropTypes.bool,

    label: PropTypes.exact({
      bold: PropTypes.string,
      suffix: PropTypes.string,
      normal: PropTypes.string,
    }).isRequired,
  }).isRequired,
  setRef: PropTypes.func.isRequired,
};
